<template>
  <!--    这是一个富文本的组件-->
  <div>
    <div class="editor_wrap">
      <upload-video
        style="display: none"
        class="quill-upload-video"
        @onProgress="uploadVedioProgress"
        @onSuccess="uploadVedioSuccess"
        @onError="uploadVedioError"
      />
      <upload-image
        style="display: none"
        class="quill-upload-img"
        @onProgress="uploadImageProgress"
        @onSuccess="uploadImageSuccess"
        @onError="uploadImageError"
      />
      <el-row v-loading="quillUpdateImg">
        <quill-editor
          ref="myQuillEditor"
          v-model="content"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        />
      </el-row>
    </div>
  </div>
</template>

<script>
// import upload from "../../utils/api/index" // 这里我封装的一个上传图片的，返回一个url地址，将它插入光标位置
import UploadImage from '@/components/UploadImage/index'
import UploadVideo from '@/components/UploadVideo/index'

import Quill from 'quill' // 引入编辑器
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// // 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = [
  '10px',
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '24px',
  '32px'
]
Quill.register(Size, true)
// quill编辑器的字体
var fonts = [
  'SimSun',
  'SimHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif'
]
var Font = Quill.import('formats/font')
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)
// quill图片可拖拽改变大小
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)

// 富文本工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
  [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
  [{ list: 'ordered' }, { list: 'bullet' }], // 列表
  [{ script: 'sub' }, { script: 'super' }], // 上下标
  [{ indent: '-1' }, { indent: '+1' }], // 缩进
  [{ direction: 'rtl' }], // 文本方向
  // [{ size: Size.whitelist }], // custom dropdown
  [{ size: ['small', 'large', 'huge'] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
  [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
  [{ font: [] }], // 字体
  [{ align: [] }], // 对齐方式
  ['clean'], // 清除字体样式
  ['image', 'video'] //, 'link','image', 'video'
]

export default {
  name: 'QuillEditorCom',
  components: {
    quillEditor,
    UploadImage,
    UploadVideo
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    toolbar:{ //是否显示工具栏
      type:Boolean,
      default:true
    },
    placeholder:{ //是否显示工具栏
      type:String,
      default:"请输入正文"
    }
  },
  data() {
    return {
      content: this.value, // 我们不能直接使用props传过来的值，先赋值到这里
      // 富文本配置项
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      editorOption: {
        placeholder: this.placeholder,
        theme: 'snow', // or 'bubble'
        modules: {
          imageResize: {
            // 调整大小组件。
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          },
          toolbar: this.toolbar?{
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function(value) {
                if (value) {
                  document.querySelector('.quill-upload-img input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
              video: function(value) {
                if (value) {
                  document.querySelector('.quill-upload-video input').click()
                } else {
                  this.quill.format('video', false)
                }
              }
            }
          }:null
        }
      }
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  methods: {
    // 图片上传中
    uploadImageProgress() {
      this.quillUpdateImg = true
    },
    // 图片上传成功后的处理
    uploadImageSuccess(imgUrl) {
      this.quillUpdateImg = false
      const quill = this.editor
      // 获取光标所在位置
      const length = quill.getSelection().index
      // 插入图片
      quill.insertEmbed(length, 'image', this.$baseUrl + imgUrl)
      // 调整光标到最后
      quill.setSelection(length + 1)
    },
    // 图片上传失败后的处理
    uploadImageError() {
      this.quillUpdateImg = false
    },

    // 图片上传中
    uploadVedioProgress() {
      this.quillUpdateImg = true
    },
    // 图片上传成功后的处理
    uploadVedioSuccess(videoUrl) {
      this.quillUpdateImg = false
      const quill = this.editor
      // 获取光标所在位置
      const length = quill.getSelection().index
      // 插入视频
      quill.insertEmbed(length, 'video', videoUrl) // 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
      // 调整光标到最后
      quill.setSelection(length + 1)
    },
    // 图片上传失败后的处理
    uploadVedioError() {
      this.quillUpdateImg = false
    },

    // 准备编辑器
    onEditorReady(editor) {},
    // 失去焦点事件
    onEditorBlur() {},
    // 获得焦点事件
    onEditorFocus() {
      console.log(
        this.editor.getSelection().index,
        '获取示例'
      )
    },
    // 监听内容变化
    onEditorChange() {
      this.$emit('input', this.content)
    }
  }
}
</script>

<style lang="less">
  .ql-toolbar {
     white-space: normal;
  }
// ::v-deep
  .editor_wrap .quill-upload-img {
    display: none;
  }
  .ql-toolbar{
    line-height: normal !important;
  }
  .editor_wrap .editor {
    line-height: normal !important;
    height: 270px;
    margin-bottom: 60px;
  }

  .editor_wrap .editor .ql-bubble .ql-editor a {
    color: #136ec2;
  }

  .editor_wrap .editor img {
    max-width: 720px;
    margin: 10px;
  }

  .ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "请输入链接地址:";
  }

  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
  }
  .editor_wrap .ql-editor {
    min-height: 300px !important;
  }
   p {
    margin: 10px;
  }
  .ql-snow .ql-tooltip::before {
    content: "链接地址";
  }
  .ql-snow .ql-tooltip a.ql-remove::before {
    content: "移除";
  }
  .ql-snow .ql-tooltip a.ql-action::after {
    content: "编辑";
  }

  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    content: "保存";
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "14px";
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
    content: "10px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
    content: "18px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
    content: "32px";
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6";
  }

  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: "标准字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
    content: "衬线字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
    content: "等宽字体";
  }
</style>



// WEBPACK FOOTER //
// src/components/RichText/index.vue